module.exports = __webpack_public_path__ + "static/media/DM-Negative-Clip-6.bcacf282.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Negative-Clip-6.mp3
// module id = 136
// module chunks = 0